import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { Wrapper } from './styled';
export var Frame = /*#__PURE__*/function (_React$Component) {
  _inherits(Frame, _React$Component);
  var _super = _createSuper(Frame);
  function Frame() {
    var _this;
    _classCallCheck(this, Frame);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var onClick = _this.props.onClick;
      if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      if (event.key !== ' ' && event.key !== 'Enter') {
        return;
      }
      var onClick = _this.props.onClick;
      if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    });
    // prevent default on mousedown to avoid inline card losing focus
    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
      e.preventDefault();
    });
    return _this;
  }
  _createClass(Frame, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isSelected = _this$props.isSelected,
        children = _this$props.children,
        onClick = _this$props.onClick,
        testId = _this$props.testId;
      var isInteractive = Boolean(onClick);
      return /*#__PURE__*/React.createElement(Wrapper, {
        isSelected: isSelected,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        onKeyPress: this.handleKeyPress,
        "data-testid": testId
      }, children);
    }
  }]);
  return Frame;
}(React.Component);